// this is intentionally very high because init is critical for the app to work
export const WAIT_FOR_LD_TIMEOUT_SECONDS = 10;

// Runtime identifies should fail fast — app already has cached flag values
// and the user should never be blocked for more than 2 seconds mid-session
export const WAIT_FOR_LD_IDENTIFY_TIMEOUT_SECONDS = 5;

export const privateAttributes = [
  'email',
  'firstName',
  'lastName',
  'name',
  'dateOfBirth',
  'phoneNumber',
];
